import { ReactNode } from "react";
import { Document, Page } from "@react-pdf/renderer";

import "../fonts";

import { styles } from "../styles";
import { PdfFooter } from "./PdfFooter";
import { PdfHeader } from "./PdfHeader";

interface PdfDocumentProps {
  documentTitle: string;
  headerTitle: string;
  children?: ReactNode;
}

export const PdfDocument = ({
  documentTitle,
  headerTitle,
  children,
}: PdfDocumentProps) => (
  <Document title={documentTitle}>
    <Page size="A4" style={styles.page}>
      <PdfHeader title={headerTitle} />
      {children}
      <PdfFooter />
    </Page>
  </Document>
);
